'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import Helmet from 'react-helmet'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _About = require('./About.css');

var _About2 = _interopRequireDefault(_About);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = (_dec = (0, _reactCssModules2.default)(_About2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About(props) {
    (0, _classCallCheck3.default)(this, About);

    var _this = (0, _possibleConstructorReturn3.default)(this, (About.__proto__ || (0, _getPrototypeOf2.default)(About)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(About, [{
    key: 'render',
    value: function render() {
      var aboutTitle = 'About Deforestation Free Funds';
      // const sriIcon = require( '../../../static/images/icn-socially-responsible.svg' )
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _container2.default.helmet(aboutTitle),
          _react2.default.createElement('div', { styleName: 'anchor', id: 'about' }),
          _react2.default.createElement(
            'div',
            { styleName: 'about' },
            _react2.default.createElement(
              'div',
              { styleName: 'about-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                aboutTitle
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Deforestation Free Funds'
                ),
                ' is a search platform that enables people to find out if their money, in the form of individual investments or an employer-provided 401(k), is exposed to companies, banks, and brands driving deforestation around the world. Deforestation Free Funds specifically looks at companies that produce, trade, consume, or finance palm oil, rubber, soy, cattle, wood products and pulp & paper \u2013 the chief commodities responsible for rainforest destruction.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'Overview'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Deforestation and degradation of vast swaths of land in order to grow and produce commodities such as palm oil, pulp and paper, soy, rubber, and cattle are responsible for almost one quarter of all global greenhouse gas emissions and for unprecedented species extinction. Simultaneously, industrial plantation agriculture is a leading cause of violent land conflicts due to its tendency to displace and dispossess indigenous peoples and local communities.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Of course, not all agricultural commodity producers are guilty of these abuses, and not all consumer brands are directly linked to the worst tropical deforestation. Some companies are making real efforts to reduce harm \u2013 and the goal of Deforestation Free Funds is to help support these efforts. By bringing more transparency to the producers, consumer brands, and lenders within the chain of rainforest destruction, we hope to keep pushing this trend forward.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Deforestation Free Funds empowers everyday investors \u2013 those of us who are not investment professionals but who may have a 401(k) or an IRA \u2013 to know exactly what they own, to see if their savings are invested in destructive commodities, to pressure fund managers to implement sustainable investment policies, and to find investment options that support a forest-friendly future. By driving transparency, we hope to encourage policies and practices that bring about real change.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'Friends of the Earth'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Friends of the Earth-United States is one of 75 national ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.foeabout, title: 'About | Friends of the Earth' },
                    'member groups of Friends of the Earth International'
                  ),
                  ', a global network representing more than two million activists in 73 different countries. In our efforts to address the challenges facing our planet, we push for the transformations that are needed, not merely the ones that are politically easy. In our efforts to halt tropical deforestation, we believe we need changes in national policies and practices in both producer and consumer countries \u2013 but we also believe that both institutional and individual investors have a role to play in reducing harm and driving positive change.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'As You Sow'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.aysabout },
                    'As You Sow'
                  ),
                  ' promotes environmental and social corporate responsibility through shareholder advocacy, coalition building, innovative legal strategies, and online financial transparency tools. We are the nation\u2019s leading non-profit organization practicing direct shareholder engagement on environmental, social, and governance issues. Founded in 1992, As You Sow believes that corporations must be willing participants in solutions to most of today\u2019s pressing issues; and we believe that shareholders are the single most powerful force for motivating that participation. We use that power to protect health and the environment and to create positive, lasting change in corporate behavior for the long-term benefit of humanity.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'In September 2015, we launched ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.fff, title: 'Fossil Free Funds | Invest Your Values | As You Sow' },
                    'Fossil Free Funds'
                  ),
                  ', a search platform that enables people to find out if their money, in the form of individual investments or an employer-provided 401(k), is being used to extract and consume fossil fuels. Since then, our ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.aysinvest, title: 'Invest Your Values | As You Sow' },
                    'Invest Your Values program'
                  ),
                  ' has grown to empower investors to know exactly what they own, and to find investment options that support their values. In addition to Deforestation Free Funds and Fossil Free Funds, we\u2019ve built ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.gef, title: 'Gender Equality Funds | Invest Your Values | As You Sow' },
                    'Gender Equality Funds'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.wff, title: 'Weapon Free Funds | Invest Your Values | As You Sow' },
                    'Weapon Free Funds'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.tff, title: 'Tobacco Free Funds | Invest Your Values | As You Sow' },
                    'Tobacco Free Funds'
                  ),
                  ', and ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.gff, title: 'Gun Free Funds | Invest Your Values | As You Sow' },
                    'Gun Free Funds'
                  ),
                  '.'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return About;
}(_react.Component)) || _class);
exports.default = About;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.js
// module id = 1314
// module chunks = 0